import request from "../request";

export const removeTicket = ({serviceId, uid}) => {
	return request({
		url: "/service/cart/remove",
		type: "DELETE",
		data: {
			service_id :serviceId,
			uid,
		},
	});
};

export const addTicket = (service_id, price_id) => {
	return request({
		url: "/service/cart/add",
		type: "POST",
		data: {
			service_id,
			price_id,
		},
	});
};

export const removeService = ({serviceId, count}) => {
	return request({
		url: "/service/cart/scope-remove",
		type: "DELETE",
		data: {
			service_id: serviceId,
			count,
		},
	});
};

export const servicesScopeAdd = ({ serviceId }) => {
	return request({
		url: '/service/cart/validate-book-form',
		type: 'POST',
		needOverlay: true,
		addCSRFToken: true,
		data: { service_id: serviceId },
	})
}

export const scopeAddRequest = (serviceId, requestData) => {
	return request({
		url: `/cart/scope-add/` + serviceId,
		type: 'POST',
		needOverlay: true,
		addCSRFToken: true,
		data: {
			...requestData,
			go_to_cart: 1
		}
	})
}
